import React from "react"
import styled, { ThemeProvider, createGlobalStyle } from "styled-components"
import theme from "styled-theming"
import Particles from "react-particles-js"

import useTheme from "../hooks/useTheme"
import Header from "./Header"

export const getBackground = theme("mode", {
  light: "#d6deeb",
  dark: "#011627",
})

export const getTextColor = theme("mode", {
  light: "#011627",
  dark: "#d6deeb",
})

const Style = createGlobalStyle`

html{
  scroll-behavior: smooth;
}

body {
      background-color: ${getBackground};
      color: ${getTextColor};
      font-family: "brandon-grotesque", sans-serif;
      font-size: 1.25rem;
      margin: 0; 
      box-sizing: border-box;
      transition: 0.5s;
      
  }

  a {
    color: inherit;
    text-decoration: none;
    transition: 0.5s; 
  }
`

const Wrapper = styled.div`
  display: flex;
  justify-content: space-evenly;
  flex-direction: column;
  min-height: 100vh;
`

const Background = styled(Particles)`
  position: fixed;
  top: 0;
  left: 0;
  z-index: -1;
  width: 100%;
  height: 100%;
`

const Layout = ({ children }) => {
  const colourTheme = useTheme()

  const params = {
    particles: {
      number: {
        value: 20,
        density: {
          enable: true,
          value_area: 800,
        },
      },
      color: {
        value: "#303346",
      },
      shape: {
        type: "polygon",
        stroke: {
          width: 0,
          color: "rgba(255,255,255,0.1)",
        },
        polygon: {
          nb_sides: 8,
        },
      },
      opacity: {
        value: 0.1,
        random: true,
        anim: {
          enable: true,
          speed: 0.15984015984015984,
          opacity_min: 0.1,
          sync: false,
        },
      },
      size: {
        value: 51.29459670609772,
        random: true,
        anim: {
          enable: true,
          speed: 1,
          size_min: 40,
          sync: false,
        },
      },
      line_linked: {
        enable: false,
        distance: 200,
        color: "#ffffff",
        opacity: 1,
        width: 2,
      },
      move: {
        enable: true,
        speed: 2,
        direction: "none",
        random: false,
        straight: false,
        out_mode: "out",
        bounce: false,
        attract: {
          enable: false,
          rotateX: 600,
          rotateY: 1200,
        },
      },
    },
    interactivity: {
      detect_on: "window",
      events: {
        onhover: {
          enable: true,
          mode: "repulse",
        },
        onclick: {
          enable: false,
          mode: "remove",
        },
        resize: true,
      },
      modes: {
        grab: {
          distance: 400,
          line_linked: {
            opacity: 1,
          },
        },
        bubble: {
          distance: 400,
          size: 40,
          duration: 2,
          opacity: 8,
          speed: 3,
        },
        repulse: {
          distance: 200,
          duration: 0.4,
        },
        push: {
          particles_nb: 4,
        },
        remove: {
          particles_nb: 2,
        },
      },
    },
    retina_detect: true,
  }

  return (
    <ThemeProvider theme={colourTheme}>
      <Style />
      <Wrapper>
        <Background params={params} />
        <Header />
        {children}
      </Wrapper>
    </ThemeProvider>
  )
}

export default Layout
